<template>
  <div>
    <div ref="bottom" @click="goBuzz()" class="to-bottom">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:class="'to-bottom__icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M13 14.6l2.3-2.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-4 4c-.4.4-1 .4-1.4 0l-4-4c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l2.3 2.3V7c0-.6.4-1 1-1s1 .4 1 1v7.6z" fill-rule="evenodd" clip-rule="evenodd"/><circle cx="11.9" cy="12" r="9.9" fill="none" stroke="#000" stroke-width="2" stroke-miterlimit="10"/></svg>
    </div>
    <header class="header-d">
      <div class="header-d__cont">
        <div class="header-d__item">
          <img class="img img_logo" src="/pages/desktop/logo.png" alt="">
        </div>
        <div class="header-d__item">
            <ul class="menu">
                <li class="menu__item">Новости</li>
                <li class="menu__item">Тест-драйвы</li>
                <li class="menu__item">Фото и видео</li>
            </ul>
        </div>
        <div class="header-d__item">
          <img class="img img_no-pad img_mob" src="/pages/desktop/burger.png" alt="">
          <img class="img img_no-pad" src="/pages/desktop/search.png" alt="">
        </div>
      </div>
    </header>
    <section class="main">
        <div class="main__cont">
            <div class="main__cont">
                <div class="main__img">
                    <img src="/pages/desktop/auto.jpg" alt="" class="img">
                </div>
                <div class="main__block">
                    <div class="main__date">12 ИЮЛЯ 2017 15:38</div>
                    <div class="main__butt">Новинки</div>
                    <div class="main__title">
                      ПРЕДСТАВЛЕНО НОВОЕ ПОКОЛЕНИЕ КУЛЬТОВЫХ ЛОНДОНСКИХ ТАКСИ
                    </div>
                </div>
            </div>
            <div class="main__block2">
                <div class="main__issue">Новое поколение знаменитых лондонских
                    такси представила компания London Taxi
                  Company, которая сейчас входит в состав китайского
                  концерна Geely. Классический черный кэб стал гибридом с
                  увеличенным запасом хода и попутно получил некоторое
                  количество фишек от Volvo.
                </div>

                <div class="main__desc">Экстерьер такси разрабатывался под
                  контролем главного стилиста концерна Питера
                  Хорбери, который предпочел сохранить кэбу узнаваемую внешность,
                  но при этом заявил, что работать над ней было
                  "так же сложно, как заботиться о драгоценностях шведской короны".
                  По его словам, срок жизни обычного
                  автомобиля, как правило, составляет около семи лет, после
                  чего следует обновление – однако, в случае с кэбом
                  этот срок увеличивается до 15-20 лет, и поэтому главной
                  задачей было добиться того, чтобы внешность такси
                  оставалась актуальной и через два десятка лет.</div>
            </div>
            <div class="main__block3">
                <div class="main__img2">
                    <img src="/pages/desktop/auto5.jpg" alt="" class="img">
                    <div class="main__link">
                      Московский каршеринг занес беспредельщиков в "черный список"
                    </div>
                </div>
                <div class="main__desc">Британцы планируют построить на
                  территории Лондона к концу следующего года до 300
                  зарядных станций – специально для таксистов. Кроме того,
                  TX eCity будет экспортироваться и в другие страны
                  Европы: к примеру, 250 кэбов уже заказали Нидерланды.
                  В Лондоне же к 2020 году потребности туристов будут
                  обеспечивать до 9 000 гибридных кэбов.</div>
            </div>
            <div class="main__block2 player-block">
                <div class="main__desc">
                  <span>В целом же интерьер кэба по имени
                  TX eCity получил ряд компонентов, которые
                  применяются в интерьерах автомобилей марки Volvo.</span>
                  <span>К примеру, шведское происхождение имеют блок мультимедийной
                  системы, рулевое колесо, рычаг переключения
                  передач и тому подобное.</span>
                  </div>
                <div ref="buzz">
                  <buzzCode @ready="ready" :id="id"></buzzCode>
                </div>

                <div class="main__desc">Благодаря увеличению доли алюминия в
                  конструкции такси удалось сделать легче,
                  просторнее и комфортнее: в пассажирской части салона
                  теперь меньше шума и вибраций. Шестиместный салон
                  получил еще и выдвижную рампу для пассажиров
                  с ограниченными возможностями.</div>

                <img src="/pages/desktop/auto2.jpg" alt="" class="img">
                <div class="main__desc">Силовая установка такси стала
                    гибридной. Электродвигатель, бензиновый турбомотор
                  объемом 1,3 л и набор аккумуляторов обеспечивают кэбу
                  запас хода в 640 км, при этом на электротяге он
                  способен проехать до 110 км. Аккумуляторы можно
                  подзаряжать от стороннего источника энергии: по сведениям
                  издания Autocar, этот процесс займет от 20 минут
                  при использовании особого зарядного устройства до 8 часов от
                  обычной розетки. По словам разработчиков,
                  среднестатистический лондонский таксист сможет экономить на топливе
                  до 100 фунтов (115 евро) в неделю по сравнению
                  с предыдущим дизельным поколением кэба.</div>
                <img src="/pages/desktop/auto3.jpg" alt="" class="img">
                <div class="main__desc">Британцы планируют построить на
                    территории Лондона к концу следующего года до 300
                  зарядных станций – специально для таксистов. Кроме того,
                  TX eCity будет экспортироваться и в другие страны
                  Европы: к примеру, 250 кэбов уже заказали Нидерланды.
                  В Лондоне же к 2020 году потребности туристов будут
                  обеспечивать до 9 000 гибридных кэбов.</div>
                <img src="/pages/desktop/auto4.jpg" alt="" class="img">
            </div>
        </div>
        <div class="main__bott">
            <div class="main__cont2">
                <div class="info">
                    <img src="/pages/desktop/auto6.jpg" alt="" class="img">
                    <div class="info__title">
                      Роскошный внедорожник Bentley получит гибридную версию
                    </div>
                    <div class="info__desc">Компания Bentley в ближайшее
                      время дополнит гамму модификаций Bentayga гибридной
                      версией, которая сможет передвигаться исключительно
                      на электротяге. Силовую установку позаимствуют у
                      Porsсhe. </div>
                </div>
            </div>
            <div class="main__cont2">
                <div class="info">
                    <img src="/pages/desktop/auto7.jpg" alt="" class="img">
                    <div class="info__title">Новый BMW X3: названа российская цена</div>
                    <div class="info__desc">Компания BMW совсем недавно официально
                      рассекретила третье поколение кроссовера
                      Х3. Теперь же стало известно, сколько будет стоить в
                      России начальная комплектация премиум-паркетника.
                    </div>
                </div>
            </div>
        </div>
    </section>
    <footer class="footer">
        <div class="footer__cont">
            <ul class="menu menu_foot">
                <li class="menu__item">Новости</li>
                <li class="menu__item">Тест-драйвы</li>
                <li class="menu__item">Фото и видео</li>
            </ul>
        </div>
    </footer>
  </div>
</template>

<script>
import buzzCode from '@/components/buzzCode.vue';

export default {
  name: 'siteDesktop3',
  data() {
    return {};
  },
  props: {
    id: {
      type: String,
    },
    platform: {
      type: String,
    },
  },
  components: {
    buzzCode,
  },
  computed: {
  },
  methods: {
    ready() {
      this.$emit('ready');
    },
    goBuzz() {
      this.$refs.buzz.scrollIntoView({
        block: 'center',
        behavior: 'smooth',
      });
      this.$refs.bottom.style.display = 'none';
    },
  },
  mounted() {
    const placement = this.$refs.buzz.getBoundingClientRect();
    this.$refs.bottom.style.display = placement.top <= 750 ? 'none' : 'block';
  },
};
</script>

<style scoped lang='stylus'>

fontSize(size, lineHeight)
  font-size ((size*0.0625)rem)
  line-height ((lineHeight/size)em)

img
  display block
  width 100%
  height auto
body
  margin 0
  padding 0

m-1280()
  @media all and (max-width: 1280px)
    {block}
m-1100()
  @media all and (max-width: 1100px)
    {block}
m-900()
  @media all and (max-width: 900px)
    {block}
m-670()
  @media all and (max-width: 670px)
    {block}

@keyframes heartbeat
  from
    transform scale(1)
    transform-origin center center
    animation-timing-function ease-out
  10%
    transform scale(0.91)
    animation-timing-function ease-in
  17%
    transform scale(0.98)
    animation-timing-function ease-out
  33%
    transform scale(0.87)
    animation-timing-function ease-in
  45%
    transform scale(1)
    animation-timing-function ease-out

@keyframes blink
  0%,
  20%,
  40%
    opacity 1
  10%,
  30%
    opacity 0


.to-bottom
  position fixed
  right 10px
  bottom 10px
  display block
  background-color white
  padding 10px
  cursor pointer
  outline none
  -webkit-tap-highlight-color transparent
  animation blink 1.5s ease-in-out infinite both
  &__icon
    display block
    width 50px
    height 50px
    fill #ff5502
    outline none
    -webkit-tap-highlight-color transparent
    transition opacity .5s ease-in
    circle
      stroke #ff5502

.img
  width 100%
  height auto
  padding 0 0px 24px 0px
  &_no-pad
    padding 0
    display inline-block
    height 38px
    width auto
    +m-670()
      display none
  &_mob
    display none
    +m-900()
      display inline-block
      margin-right 10px
    +m-670()
      margin 0
  &_logo
    height 18px
    width auto
    padding 0

.header-d
  width 100%
  background-color rgba(255, 255, 255, .9)
  border-bottom 1px solid #a1a1a1
  &__cont
    display flex
    justify-content space-between
    align-items center
    margin 0 auto
    width 100%
    max-width 1104px
    padding 15px 24px
    box-sizing border-box
    +m-670()
      padding 15px 24px 5px
  &__item
    display inline-block

.main
  max-width 750px
  margin 0 auto
  overflow hidden
  background-color white
  +m-900()
    padding 0 24px
  +m-670()
    margin 0
  &__cont
    margin 0 auto
    width 100%
    max-width 1004px
    padding 12px 0 0
    box-sizing border-box
    font-size 0
    +m-900()
      max-width 528px
      width 100%
  &__img
    display inline-block
    width 50%
    +m-1100()
      width 100%
  &__img2
    margin 0 24px 24px 0
    width 288px
    float left
    +m-1100()
      width 100%
      float none
  &__block
    display inline-block
    width 50%
    position relative
    top -35px
    +m-1100()
      width 100%
      top 0
  &__date
    font-weight 300
    font-style normal
    font-size 10px
    font-family 'Open Sans', Verdana, sans-serif;
    text-transform uppercase
    text-decoration none
    line-height 10px
    color #ff0147
    display block
    padding 10px 0
    margin 0 0 0 24px
    +m-900()
      margin 0 0 12px
  &__butt
    font-weight 300
    font-style normal
    font-size 10px
    font-family 'Open Sans', Verdana, sans-serif;
    text-transform uppercase
    text-decoration none
    line-height 10px
    color #fff
    display inline-block
    padding 10px 18px
    margin 0 0 24px 24px
    background #ff0147
    +m-900()
      margin 0 0 12px
  &__title
    font-weight 300
    font-style normal
    font-size 25px
    font-family 'Open Sans', Verdana, sans-serif;
    text-transform uppercase
    text-decoration none
    line-height 37.5px
    color #000
    margin 0 0 0 24px
    +m-900()
      margin 0
      padding 0
    +m-670()
      font-size 18px
      line-height 27px
  &__link
    font-weight 300
    font-style normal
    font-size 16px
    font-family 'Open Sans', Verdana, sans-serif
    text-transform none
    text-decoration underline
    line-height 24px
    color #ff0147
  &__block2
    width 100%
    padding 0 20px 24px
    box-sizing border-box
    +m-900()
      width 100%
      padding 0 20px 24px
    +m-670()
      padding 0
  &__block3
    width 100%
    padding 0 20px 24px
    box-sizing border-box
    +m-900()
      width 100%
      padding 0
  &__issue
    font-weight 600
    font-style normal
    font-size 18px
    font-family 'Open Sans', Verdana, sans-serif;
    text-transform none
    text-decoration none
    line-height 27px
    color #565656
    margin 0 auto
    padding-bottom 24px
  &__desc
    font-weight 300
    font-style normal
    font-size 18px
    font-family 'Open Sans', Verdana, sans-serif;
    text-transform none
    text-decoration none
    line-height 27px
    color #565656
    margin 0 auto
    padding-bottom 24px
  &__bott
    margin 0 auto
    width 100%
    max-width 1104px
    padding 12px 0 0
    box-sizing border-box
    font-size 0
  &__cont2
    display inline-block
    width 45%
    margin-right 10%
    margin-bottom 5%
    vertical-align top
    &:last-child
      margin-right 0
    +m-670()
      width 100%

.info
  &__title
    font-weight 300
    font-style normal
    font-size 25px
    font-family 'Roboto', Verdana, sans-serif
    text-transform none
    text-decoration none
    line-height 30px
    color #000
    display block
    margin 12px 0 0
  &__desc
    font-weight 400
    font-style normal
    font-size 16px
    font-family 'Open Sans', Verdana, sans-serif
    text-transform none
    text-decoration none
    line-height 24px
    color #565656
    display block
    margin 12px 0 0

.menu
  list-style-type none
  margin 0
  padding 0
  color #000
  +m-1100()
    display none
  &_foot
    color white
    margin 0 auto 0
    padding 0 0 17px
    text-align center
    &^[0]__item
      &:hover
        color #ff0147
  &__item
    display inline-block
    padding 14px
    font-size 16px
    line-height 16px
    border none
    outline none
    vertical-align middle
    font-family Roboto, Verdana, sans-serif
    cursor pointer
    border-radius 3px
    transition all .5s
    &:hover
      background #ff0147
      color #fff

.footer
  background-color #252525
  text-align center
  padding 24px
  &__cont
    margin 0 auto
    width 100%
    max-width 1104px
    box-sizing border-box
    border-bottom 1px solid #565656
    +m-900()
      padding 24px
</style>
